<template>
  <div class="User-MyAcount">
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'min-height:400px;overflow:hidden;' : ''">
      <div class="User-MyAcount-Nav" v-if="AccountData">
      <div class="User-MyAcount-Header">
        <div class="User-MyAcount-Header-Title">
          {{ $t('EMP_UserSetting_MyAccount') }}
        </div>
        <div class="User-MyAcount-Header-Tips">
          {{ $t('EMP_UserSetting_MyAccountTip') }}
        </div>
      </div>
      <div class="AccountCard">
        <div class="AccountCard-Img">
          <img v-if="AccountData?.userLogo" :src="AccountData?.userLogo" />
          <div v-if="!AccountData?.userLogo" class="AccountCard-Img-None">
            <div class="AccountCard-Img-None-text"
              v-html="DefaultCompanyfirstName(langid == 1252 ? AccountData?.personNameEn : AccountData?.personNameSc)">
            </div>
          </div>
        </div>
        <div class="AccountCard-Info">
          <div class="AccountCard-Name">
            <div class="AccountCard-Names">{{ langid == 1252 ? AccountData?.personNameEn : AccountData?.personNameSc }}
            </div>
            <div class="AccountCard-Person" v-if="AccountData?.IsContactPerson">{{ $t('EMP_UserSetting_ContactPerson') }}</div>
            <div class="AccountCard-Representative" v-if="AccountData?.isDisplayContactCard == 1">{{ $t('lbl_EMPBE_eBoothRepresentative') }}</div>
            <div class="AccountCard-Member" v-if="AccountData?.userRole">({{ GetUserRoleLabel(AccountData?.userRole) }})</div>
          </div>
          <div class="AccountCard-Job AccountCardInfoMsg">{{ langid == 1252 ? AccountData?.jobTitleEn :
            AccountData?.jobTitleSc }}</div>
          <div class="AccountCard-Phone AccountCardInfoMsg" v-if="AccountData?.phoneValue">{{ GetPhoneTitle(AccountData)
          }}<i
              :class="`${AccountData?.phoneIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'}`"></i>
          </div>
          <div class="AccountCard-Email AccountCardInfoMsg" v-if="AccountData?.emailValue">{{ AccountData?.emailValue
          }}<i
              :class="`${AccountData?.emailIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'}`"></i>
          </div>
          <div class="AccountCard-Password AccountCardInfoMsg" v-if="AccountData?.passwordValue">
            {{ $t('lbl_emp2_Password') }}
            <i :class="AccountData?.passwordIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'"></i>
          </div>
          <div class="AccountCard-OtherContact" v-if="false"><i class="icon"></i><i class="icon"></i><i
              class="icon"></i></div>
        </div>
        <div class="AccountCard-Edit">
          <b-button variant="outline-primary" v-bind:t_label="'EMP_UserSetting_Edit'"
            @click="ShowDialogFunc()">
            {{ $t('EMP_UserSetting_Edit') }}
          </b-button>
        </div>
      </div>
    </div>

    </b-overlay>
    <UserSettingDialog v-model="Showdialog" :IsHidenRole="true" :DilogTitle="$t('EMP_UserSetting_Edit')" :AccountUserId="AccountData?.accountUserId">
    </UserSettingDialog>
  </div>
</template>

<script>
import { userService,CompanyInfoService } from "../../_services";
import UserSettingDialog from './UserSettingDialog.vue';
export default {
  components: {
    UserSettingDialog
  },
  props: [],
  data() {
    return {
      cellCountryOptions: [],
      Showdialog: false,
      AccountData: {},
      loading: true,
    }
  },
  computed: {
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  watch: {
    Showdialog() {
      if (!this.Showdialog) {
        this.GetUserMyAccountFunc();
      }
    },
  },
  created() {

  },
  mounted() {
    this.GetUserMyAccountFunc();
    this.getCellCountryOptions();
  },
  methods:
  {
    GetPhoneTitle(item) {
      var PhonePrefix = this.cellCountryOptions.find(a => a.id == item.phoneCountry)?.label;
      return PhonePrefix + " " + item.phoneValue
    },
    async getCellCountryOptions() {
      this.cellCountryOptions = (await CompanyInfoService.GetCellCountryData()).map(item => {
        return {
          id: item.Code,
          label: '+' + item.Option
        }
      });
    },
    GetUserRoleLabel(userRole) {
      if (!userRole) return '';
      const roleLower = String(userRole).toLowerCase();
      if (roleLower === 'admin') {
        return this.$t('EMP_UserSetting_Role_Admin');
      } else if (roleLower === 'member') {
        return this.$t('EMP_UserSetting_Role_Member');
      }
      return userRole;
    },
    DefaultCompanyfirstName(Name) {
      // 检查Name是否存在且为字符串
      if (!Name || typeof Name !== 'string') {
        return "";
      }

      // 安全地调用replaceEmTag方法（如果存在）
      let processedName = Name;
      if (typeof Name.replaceEmTag === 'function') {
        processedName = Name.replaceEmTag();
      }

      // 移除非中文、英文字母和数字的字符
      const cleanedName = processedName.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');

      // 返回第一个字符，如果是英文字母则转换为大写
      if (cleanedName.length > 0) {
        const firstChar = cleanedName[0];
        // 如果是英文字母，转换为大写
        if (/[a-zA-Z]/.test(firstChar)) {
          return firstChar.toUpperCase();
        }
        return firstChar;
      }
      return "";
    },
    async GetUserMyAccountFunc() {
      this.loading = true;
      try {
        const res = await userService.GetUserMyAccount();
        this.AccountData = res.data;
        if (this.AccountData) {
          this.$set(
            this.AccountData,
            'IsContactPerson',
            this.AccountData.notifySystem == '1'
              || this.AccountData.notifySourcing == '1'
              || this.AccountData.notifyEnquiry == '1'
              || this.AccountData.notifyAds == '1'
              || this.AccountData.notifyNameCard == '1'
              ? true
              : false
          );
        }
      } catch (error) {
        console.error('GetUserMyAccount error:', error);
      } finally {
        this.loading = false;
      }
    },

    ShowDialogFunc() {
      this.Showdialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.User-MyAcount {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .AccountCard-Img-None {
    width: 78px;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    background: linear-gradient(0deg, rgba(115, 102, 255, 0.08) 0%, rgba(115, 102, 255, 0.08) 100%);
    overflow: hidden;
    border: 1px solid #7366FF;
  }

  .AccountCard-Img-None-Pen {
    position: absolute;
    right: 0px;
    bottom: 0px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .AccountCard-Img-None-text {
    color: #7366FF;
    font-size: 32px;
    font-weight: 700;
    line-height: 41.60px;
    word-wrap: break-word
  }


  .User-MyAcount-Nav {
    background: white;
    box-shadow: 0px 2px 15px rgba(183, 183, 183, 0.30);
    border-radius: 24px;
    padding: 24px;
    gap: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    width: 710px;
    align-items: flex-start;
  }

  .User-MyAcount-Header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 24px;

    .User-MyAcount-Header-Title {
      color: rgba(0, 0, 0, 0.80);
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
      word-wrap: break-word
    }

    .User-MyAcount-Header-Tips {
      color: rgba(0, 0, 0, 0.60);
      font-size: 14px;
      font-weight: 400;
      line-height: 18.20px;
      word-wrap: break-word
    }
  }

  .AccountCard {
    padding: 16px;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    outline: 1px rgba(0, 0, 0, 0.10) solid;

    .AccountCard-Img {
      width: 78px;
      display: flex;
      justify-content: center;
      position: relative;
    }

    .AccountCard-Img img {
      width: 78px;
      height: 78px;
      -o-object-fit: contain;
      object-fit: contain;
      border-radius: 999px;
      display: block;
      background: #fff;
    }

    .AccountCard-Info {
      flex: 2;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 8px;

      .AccountCard-Name {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
      }

      .AccountCard-Names {
        color: rgba(0, 0, 0, 0.80);
        font-size: 16px;
        font-weight: 700;
        line-height: 20.80px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
        max-width: 300px;
      }

      .AccountCard-Person {
        padding: 4px 6px;
        background: #F1E7FF;
        border-radius: 25px;
        color: rgba(0, 0, 0, 0.80);
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        word-wrap: break-word;
        text-box-trim: trim-both;
        text-box-edge: cap alphabetic;
        text-align: center;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
      }

      .AccountCard-Member {
        color: rgba(0, 0, 0, 0.60);
        font-size: 12px;
        font-style: italic;
        font-weight: 400;
        line-height: 15.60px;
        word-wrap: break-word
      }

      .AccountCard-Representative {
        padding: 4px 6px;
        background: #ffe7e7;
        border-radius: 25px;
        color: rgba(0, 0, 0, 0.80);
        font-size: 12px;
        font-family: Inter;
        font-weight: 600;
        line-height: 18px;
        word-wrap: break-word;
        text-box-trim: trim-both;
        text-box-edge: cap alphabetic;
        text-align: center;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
      }

      .AccountCardInfoMsg {
        color: rgba(0, 0, 0, 0.60);
        font-size: 14px;
        font-weight: 400;
        line-height: 18.20px;
        word-wrap: break-word;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .AccountCard-NotSetUp {
        font-size: 12px;
        font-weight: 400;
        line-height: 130%; /* 15.6px */
        color: rgba(0, 0, 0, 0.60);
      }
      
      .AccountCard-Job.AccountCardInfoMsg {
        display: block !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        min-width: 0 !important;
        max-width: 300px !important;
        word-wrap: normal !important;
        width: 100%;
        box-sizing: border-box;
      }

      .btn.btn-outline-primary {
        padding: .375rem .75rem;
      }
    }

  }
}
</style>
